import Splide from '@splidejs/splide'

((Drupal, once, Splide) => {
  Drupal.behaviors.slideshow = {
    attach: function (context, settings) {
      once('slideshow', '.landmarks-short-videos__slides .splide', context)
        .forEach(element => {
          const slides = new Splide(element, {
            pagination: false, arrows: false, type: 'fade'
          })

          const thumbnailWrapper = element.parentElement.parentElement.querySelector('.landmarks-short-videos__thumbnails .splide')
          const thumbnailElements = thumbnailWrapper.querySelectorAll('li.splide__slide')

          const thumbnails = new Splide(thumbnailWrapper, {
            isNavigation: true,
            pagination: false,
            arrows: true,
            type: 'slide',
            direction: 'ltr',
            perPage: 3,
            perMove: 0,
            gap: '1rem',
            updateOnMove: false,
            padding: {
              'left': '1rem', 'right': '1rem'
            },
            mediaQuery: 'min',
            breakpoints: {
              1024: {
                direction: 'ttb', height: '450px'
              }
            }
          })

          /* Stop player on transition */
          slides.on('inactive', function () {
            document.querySelector('.is-playing button')?.click()
          })

          /* Activate thumbnail nav */
          thumbnailElements.forEach(function (thumbnail, index) {
            thumbnail.addEventListener('click', (event) => {
              event.preventDefault()
              slides.go(index)
            })
          })

          /* Thumbnail classes */
          var current
          slides.on('mounted move', function () {
            var thumbnail = thumbnails[slides.index]
            if (thumbnail) {
              if (current) {
                current.classList.remove('is-active')
              }
              thumbnail.classList.add('is-active')
              current = thumbnail
            }
          })

          slides.sync(thumbnails)
          slides.mount()
          thumbnails.mount()
        })
    }
  }
})(Drupal, once, Splide)
